import { createContext, useContext } from 'react';
import type { Organization } from './types';

export const orgsQueryKey = ['organizations'] as const;
export const ACTIVE_ORG_STORAGE_KEY = 'content-agents:activeOrgId';

export interface ActiveOrgContextValue {
  organizations: Organization[];
  activeOrg: Organization | null;
  activeOrgId: string | null;
  setActiveOrgId: (id: string) => void;
  isLoading: boolean;
}

export const ActiveOrgContext = createContext<ActiveOrgContextValue | null>(null);

export function useActiveOrg(): ActiveOrgContextValue {
  const ctx = useContext(ActiveOrgContext);
  if (!ctx) throw new Error('useActiveOrg must be used within an ActiveOrgProvider');
  return ctx;
}
